import { BulkJob, BulkJobFailure } from '../../../domain/bulk/types';

export type RawBulkJob = Omit<BulkJob, 'failures' | 'failuresTotal' | 'failuresNextOffset'> &
  Record<string, unknown>;

export function mapBulkJob(raw: RawBulkJob): BulkJob {
  const failures = readFailures(raw['failures']);
  const failuresTotal = readNumber(raw['failuresTotal']);
  const failuresNextOffset = readNumber(raw['failuresNextOffset']);

  return {
    ...raw,
    failures,
    failuresTotal: failuresTotal ?? failures.length,
    failuresNextOffset,
  };
}

function readFailures(value: unknown): BulkJobFailure[] {
  if (!Array.isArray(value)) {
    return [];
  }

  return value
    .filter((item): item is BulkJobFailure => !!item && typeof item === 'object')
    .map(item => ({
      phoneNumber: String(item.phoneNumber ?? ''),
      reason: String(item.reason ?? ''),
    }));
}

function readNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
